import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function LeaderboardSkeleton() {
  return (
    <div className="min-h-screen bg-background pb-24 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-16 left-4 opacity-10">
        <Skeleton className="h-12 w-12 rounded" />
      </div>
      <div className="absolute bottom-20 right-6 opacity-10">
        <Skeleton className="h-16 w-16 rounded-full" />
      </div>

      <div className="max-w-md mx-auto space-y-4 relative z-10 p-4">
        {/* Category Tabs */}
        <Card className="p-1">
          <div className="grid grid-cols-4 gap-1">
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} className="h-10 rounded-md" />
            ))}
          </div>
        </Card>

        {/* Filters */}
        <Card className="p-4">
          <Skeleton className="h-10 w-full rounded-lg" />
        </Card>

        {/* Podium */}
        <div className="flex justify-center items-end gap-4 py-8">
          {/* 2nd Place */}
          <div className="flex flex-col items-center">
            <Skeleton className="h-16 w-16 rounded-full mb-2" />
            <Skeleton className="h-4 w-20 mb-1" />
            <Skeleton className="h-3 w-16" />
          </div>
          {/* 1st Place */}
          <div className="flex flex-col items-center">
            <Skeleton className="h-20 w-20 rounded-full mb-2" />
            <Skeleton className="h-4 w-24 mb-1" />
            <Skeleton className="h-3 w-20" />
          </div>
          {/* 3rd Place */}
          <div className="flex flex-col items-center">
            <Skeleton className="h-14 w-14 rounded-full mb-2" />
            <Skeleton className="h-4 w-20 mb-1" />
            <Skeleton className="h-3 w-16" />
          </div>
        </div>

        {/* Rankings List - Dynamic based on screen */}
        <Card className="p-4">
          <div className="space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex items-center gap-4 p-3 bg-card/50 rounded-lg">
                <Skeleton className="h-6 w-6 rounded" />
                <Skeleton className="h-12 w-12 rounded-full" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-32" />
                  <Skeleton className="h-3 w-24" />
                </div>
                <Skeleton className="h-6 w-16 rounded-full" />
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
